import { toRem } from "../../../../helpers/theme";
import { normalizeDimension } from "../../../../helpers/utils";

const style = ({ maxWidth }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    margin: "auto",
    maxWidth: normalizeDimension(maxWidth, true) || toRem(380),
});

export default style;
